"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCurrentQuestionNumber = useCurrentQuestionNumber;
exports.useCurrentQuizId = useCurrentQuizId;
exports.useSearchParams = useSearchParams;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _reactRedux = require("react-redux");
function useSearchParams() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var location = (0, _reactRouterDom.useLocation)();
  var _ref = (0, _react.useState)(new URLSearchParams(location.search)),
    _ref2 = _slicedToArray(_ref, 2),
    searchParams = _ref2[0],
    setSearchParams = _ref2[1];
  (0, _react.useEffect)(function () {
    setSearchParams(new URLSearchParams(location.search));
  }, _toConsumableArray(values));
  return searchParams;
}
function useCurrentQuizId() {
  var inSearch = (0, _reactRouterDom.useMatch)('/search/:quiz_id?/:filter?/:question_number?');
  var searchId = (0, _reactRedux.useSelector)(function (state) {
    return state.session.get('search_id');
  });
  var quizId = inSearch ? searchId : (0, _reactRouterDom.useParams)().quiz_id;
  return parseInt(quizId);
}
function useCurrentQuestionNumber() {
  return parseInt((0, _reactRouterDom.useParams)().question_number);
}